import { Component, inject, Input } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DeviceService } from "@app/shared/services/device.service";

@Component({
    selector: "app-comparation-percentage-value",
    imports: [MatTooltipModule],
    templateUrl: "./comparation-percentage-value.component.html",
    styleUrl: "./comparation-percentage-value.component.scss"
})
export class ComparationPercentageValueComponent {
    @Input() tooltip: string;
    @Input() polarityColor: string;
    @Input() icon: string;
    @Input() percentage: string;
    @Input() pdfMode: boolean = false;
    @Input() isSpecialChart: boolean = false;

    private readonly deviceService = inject(DeviceService);
    public readonly isMobile = this.deviceService.getIsMobile();
}
